// extracted by mini-css-extract-plugin
export default {"bgCard":"Services_bgCard__MsHef","color":"Services_color__uZ9mc","imgSizeProj":"Services_imgSizeProj__knlVc"};